export default function useAudioService (inputDevice = 0) {
  let audioContext = null
  let audioStream = null
  let mediaRecorder = null
  let keepAliveInterval = null

  const initAudio = async () => {
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        throw new Error('MediaDevices API not supported.')
      }

      const devices = await navigator.mediaDevices.enumerateDevices()
      const audioInputs = devices.filter(device => device.kind === 'audioinput')

      if (audioInputs.length === 0) {
        throw new Error('No audio input devices found.')
      }

      const selectedDevice = audioInputs[inputDevice]
      console.log(selectedDevice)
      if (!selectedDevice) {
        throw new Error(`Invalid input device index: ${inputDevice}`)
      }

      audioStream = await navigator.mediaDevices.getUserMedia({
        audio: {
          deviceId: selectedDevice.deviceId,
          channelCount: 1,
          sampleRate: 16000,
          echoCancellation: true,
          noiseSuppression: true
        }
      })

      audioContext = new (window.AudioContext || window.webkitAudioContext)({
        sampleRate: 16000
      })

      const mimeType = getSupportedMimeType()

      mediaRecorder = new MediaRecorder(audioStream, {
        mimeType: mimeType,
        audioBitsPerSecond: 16000
      })

      const sendAudioChunk = deepgramConnection => {
        mediaRecorder.ondataavailable = event => {
          if (deepgramConnection.getReadyState() === 1) {
            const reader = new FileReader()
            reader.onload = () => {
              const arrayBuffer = reader.result
              deepgramConnection.send(arrayBuffer)
            }
            reader.readAsArrayBuffer(event.data)
          }
        }
        mediaRecorder.onstop = () => {
          console.log('MediaRecorder stopped, final chunks sent')
        }
      }

      return { audioStream, mediaRecorder, sendAudioChunk }
    } catch (error) {
      console.error('Audio init failed:', error)
      cleanup()
      throw error
    }
  }

  const getSupportedMimeType = () => {
    const types = [
      'audio/webm;codecs=opus',
      'audio/webm',
      'audio/ogg;codecs=opus',
      'audio/mp4'
    ]
    for (const type of types) {
      if (MediaRecorder.isTypeSupported(type)) return type
    }
    console.warn('No preferred MIME types supported, using default')
    return 'audio/webm'
  }

  const startMediaRecorder = (recorder, chunkSize = 1000) => {
    if (recorder && recorder.state !== 'recording') {
      recorder.start(chunkSize)
    }
  }

  const cleanup = () => {
    if (keepAliveInterval) {
      clearInterval(keepAliveInterval)
      keepAliveInterval = null
    }
    if (mediaRecorder) {
      mediaRecorder.stop()
      mediaRecorder.ondataavailable = null
      mediaRecorder.onstop = null
      mediaRecorder.onerror = null
      mediaRecorder = null
    }
    if (audioStream) {
      audioStream.getTracks().forEach(track => {
        track.stop()
        console.log('Track stopped:', track.id)
      })
      audioStream = null
    }
    if (audioContext) {
      audioContext
        .close()
        .then(() => console.log('AudioContext closed'))
        .catch(err => console.error('Error closing AudioContext:', err))
      audioContext = null
    }
    console.log('Cleanup complete')
  }

  return {
    initAudio,
    startMediaRecorder,
    cleanup
  }
}
